import React, { useState } from 'react';
import { Configure, SearchBox } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

import PropertyContactsSearchHits from './PropertyContactsSearchHits';
import SearchContainer from '@search/SearchContainer';

const PropertyContactsSearch = ({ onContactSelect }) => {
    const [displayNewContactResults, setDisplayNewContactResults] = useState(false);

    return (
        <SearchContainer index="members">
            <Configure hitsPerPage={5} />

            <div className="relative">
                <div className="mb-2rem">
                    <SearchBox
                        translations={{
                            placeholder: 'Search and Add Contacts...',
                        }}
                        onChange={() => setDisplayNewContactResults(true)}
                        onBlur={() => setDisplayNewContactResults(false)}
                    />
                </div>

                <PropertyContactsSearchHits displayResults={displayNewContactResults} onSelect={onContactSelect} />
            </div>
        </SearchContainer>
    );
};

PropertyContactsSearch.propTypes = {
    onContactSelect: PropTypes.func,
};

export default PropertyContactsSearch;
